import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
// import Confetti from "react-confetti";
// import { useWindowSize } from "react-use";

import { useUser } from "../../contextApi/userContext";
import { toast } from "react-toastify";
import axios from "axios";
import API_URL from "../../../config";
import { useNavigate } from "react-router-dom";

const BookingSuccess = ({ pointsEarned = 0 }) => {
  // const { width, height } = useWindowSize();
  // const [showConfetti, setShowConfetti] = useState(true);
  const [isLogin, setIsLogin] = useState(true);
  const { setUserDetails, userDetails, isLoggedIn } = useUser();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    firstName: userDetails?.firstName || "",
    lastName: userDetails?.lastName || "",
    email: userDetails?.email || "",
    phone: userDetails?.phone || "",
    password: "",
  });

  // useEffect(() => {
  //   const timer = setTimeout(() => setShowConfetti(false), 5000);
  //   return () => clearTimeout(timer);
  // }, []);

  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      firstName: userDetails?.firstName || "",
      lastName: userDetails?.lastName || "",
      email: userDetails?.email || "",
      phone: userDetails?.phone || "",
    }));
  }, [userDetails]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      ...form,
      pointsEarned: pointsEarned,
      password: form.password,
    };

    const endpoint = isLogin ? "/layout/signin" : "/layout/signup";

    try {
      const res = await axios.post(`${API_URL}${endpoint}`, payload);
      const { success, token, user } = res.data;
      console.log("response is here", res.data.user);
      if (success && token && user) {
        toast.success(isLogin ? "Login successful!" : "Signup successful!");
        localStorage.setItem("userDetails", JSON.stringify({ ...user, token }));
        setUserDetails({ ...user, token });
        console.log("payload in rewards", payload);

        setForm({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          password: "",
        });

        navigate("/wallet");
      } else {
        toast.error("Please fill all the required fields");
      }
    } catch (error) {
      console.log("error", error)
      toast.error(error.response.data.error);
    }
    // finally {
    //   setIsSubmitting(false);
    // }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center my-5">
      <div className="col-lg-4 col-md-6 col-11">
        <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
          <div className="card-body px-3 px-md-3">
            <AnimatePresence mode="wait">
              <motion.div
                key={isLogin ? "login" : "signup"}
                initial={{ x: 50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -50, opacity: 0 }}
                transition={{ duration: 0.4 }}
              >
                {/* Header with Logo/Icon */}
                <div className="text-center mb-4">
                  <h4 className="fw-bold mb-0">
                    {isLogin
                      ? "Login to Claim Your Points"
                      : "Create Your Account"}
                  </h4>
                  <p className="text-muted small mt-2">
                    {isLogin
                      ? "Sign in to access your rewards"
                      : "Join now to start earning points"}
                  </p>
                </div>

                <form onSubmit={handleSubmit}>
                  {!isLogin && (
                    <div className="row g-2 mb-3">
                      <div className="col-md-6">
                        <div className="">
                          <input
                            type="text"
                            className="form-control rounded-3"
                            id="firstName"
                            name="firstName"
                            placeholder="First name "
                            value={form.firstName}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="">
                          <input
                            type="text"
                            className="form-control rounded-3"
                            id="lastName"
                            name="lastName"
                            placeholder="Last name "
                            value={form.lastName}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <div className=" mb-3">
                    <input
                      type="email"
                      className="form-control rounded-3"
                      id="email"
                      name="email"
                      placeholder="Enter email address "
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <input
                      type="tel"
                      className="form-control rounded-3"
                      id="phone"
                      name="phone"
                      placeholder="Enter phone number "
                      value={form.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className=" mb-3">
                    <input
                      type="password"
                      className="form-control rounded-3"
                      name="password"
                      placeholder={isLogin ? "Password" : "Create Password"}
                      value={form.password}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <motion.button
                    type="submit"
                    className="w-100 rounded-pill"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    style={{
                      background: "#c69933",
                      border: "2px solid #c69933",
                      color: "white",
                    }}
                  >
                    {isLogin ? "Login" : "Sign Up"}
                  </motion.button>
                </form>

                <div className="d-flex align-items-center">
                  <hr className="flex-grow-1" />
                  <span className="mx-3 text-muted small">or</span>
                  <hr className="flex-grow-1" />
                </div>

                <p className="text-center mb-0">
                  {isLogin
                    ? "Don't have an account?"
                    : "Already have an account?"}{" "}
                  <button
                    className=" p-0 fw-bold text-decoration-none"
                    onClick={() => setIsLogin(!isLogin)}
                    type="button"
                    style={{
                      border: "none",
                      background: "none",
                      color: "#c69933",
                    }}
                  >
                    {isLogin ? "Sign up now" : "Login here"}
                  </button>
                </p>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingSuccess;
